<div class="col-md-12">
  <div class="card">
    <div class="card-content">
      <div class="bootstrap-table">
        <div class="fixed-table-toolbar">
          <div class="pull-left search">
            <div class="input-group">
              <input
                name="invoice-date"
                class="form-control"
                type="date"
                [formControl]="invoiceDate"
                [readonly]="mode === 'generate'"
              >
            </div>
          </div>
          <div class="columns columns-right">
            <button class="btn btn-default" title="Preview" (click)="previewInvoices()" *ngIf="mode === 'preview'" >
                  Preview
              </button>
              <button class="btn btn-default" title="Generate" (click)="confirmGenerate()" *ngIf="mode === 'generate'" >
                Generate
              </button>
              <button class="btn btn-primary" title="Email all invoices" (click)="confirmEmailAll()" *ngIf="mode === 'complete'" [disabled]="batchSending">
                <i class="fa" [ngClass]="batchSending ? 'fa-spinner fa-spin' : 'fa-envelope'"></i>
                {{ batchSending ? 'Emailing...' : 'Email All' }}
              </button>
              <button class="btn btn-danger" title="Reset" (click)="reset()" *ngIf="mode === 'generate' || mode === 'complete'" [disabled]="batchSending">
                Reset
              </button>
          </div>
        </div>
        <div class="fixed-table-container">
          <div class="fixed-table-body">
            <table class="table" *ngIf="invoices && invoices.length > 0">
              <thead>
                <tr>
                  <th *ngIf="mode == 'complete'">Invoice Number</th>
                  <th>Date</th>
                  <th>Member</th>
                  <th>Total</th>
                  <th>Item</th>
                  <th>Amount</th>
                  <th>Share</th>
                  <th *ngIf="mode == 'complete'">Email</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let invoice of invoices">
                  <!-- Parent invoice row -->
                  <tr class="invoice-row" [class.invoice-row--failed]="hasFailed(invoice)">
                    <td *ngIf="mode == 'complete'">
                      <span class="badge badge-info">{{ invoice.id }}</span>
                    </td>
                    <td>{{ invoice.invoiceDate | date: 'dd/MM/yyyy' }}</td>
                    <td>{{ invoice.fullName }}</td>
                    <td>{{ invoice.total | currency: 'GBP':'symbol' }}</td>

                    <!-- Empty item cells for parent -->
                    <td colspan="3"></td>

                    <td *ngIf="mode == 'complete'" class="email-cell">
                      <ng-container [ngSwitch]="emailStatus[invoice.id]?.state">
                        <span *ngSwitchCase="'sending'" class="label label-info">
                          <i class="fa fa-spinner fa-spin"></i> Sending...
                        </span>
                        <span *ngSwitchCase="'sent'" class="label label-success">
                          Sent {{ invoice.emailedOn | date: 'dd/MM/yyyy HH:mm' }}
                        </span>
                        <span *ngSwitchCase="'failed'" class="label label-danger">Failed</span>
                      </ng-container>
                      <button
                        class="btn btn-xs btn-info"
                        [title]="hasFailed(invoice) ? 'Retry email' : 'Email invoice'"
                        [disabled]="batchSending || isSending(invoice)"
                        (click)="emailOne(invoice)"
                      >
                        <i class="fa" [ngClass]="hasFailed(invoice) ? 'fa-redo' : 'fa-envelope'"></i>
                      </button>
                      <div *ngIf="hasFailed(invoice)" class="email-error">{{ emailStatus[invoice.id]?.error }}</div>
                    </td>
                  </tr>

                  <!-- Child item rows -->
                  <tr *ngFor="let item of invoice.items" class="item-row">
                    <td *ngIf="mode == 'complete'"></td> <!-- Empty cell for Invoice Number -->
                    <td></td> <!-- Empty cell for Date -->
                    <td></td> <!-- Empty cell for Member -->
                    <td></td> <!-- Empty cell for Total -->

                    <!-- Now filling in Item-specific data -->
                    <td class="item-cell">{{ item.name }}</td>
                    <td>{{ item.amount | currency: 'GBP':'symbol' }}</td>
                    <td>{{ item.share | percent: '1.0-0' }}</td>
                    <td *ngIf="mode == 'complete'"></td> <!-- Empty cell for Email -->
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-confirm-dialog
  *ngIf="showConfirmDialog"
  [title]="'Confirm Invoice Generation'"
  [message]="confirmationText"
  (confirm)="generateInvoices()"
  (cancel)="cancelGenerate()"
></app-confirm-dialog>
<app-confirm-dialog
  *ngIf="showEmailConfirmDialog"
  [title]="'Confirm Invoice Emails'"
  [message]="emailConfirmationText"
  (confirm)="emailAll()"
  (cancel)="cancelEmailAll()"
></app-confirm-dialog>
